import React from "react";
import cn from "classnames";
import styles from "./AscSwitch.module.scss";

export interface AscSwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  className?: string;
  prependLabel?: string;
  prependLabelClass?: string;
  appendLabel?: string;
  appendLabelClass?: string;
}

export default function AscSwitch({
  value,
  onChange,
  disabled = false,
  className,
  prependLabel,
  prependLabelClass,
  appendLabel,
  appendLabelClass,
}: AscSwitchProps) {
  return (
    <div data-testid="asc-switch" className={cn(styles.ground, className)}>
      <label
        className={cn(styles.prependLabel, prependLabelClass)}
        onClick={() => !disabled && onChange(false)}
      >
        {prependLabel}
      </label>
      <div
        className={cn(
          styles.toggle,
          value ? styles.toggleActive : styles.toggleInactive,
          disabled && styles.toggleDisabled
        )}
        onClick={() => !disabled && onChange(!value)}
      >
        <div className={styles.toggleCircle1} />
        <div className={styles.toggleCircle2} />
      </div>
      <label
        className={cn(styles.appendLabel, appendLabelClass)}
        onClick={() => !disabled && onChange(true)}
      >
        {appendLabel}
      </label>
    </div>
  );
}
